   export const BASE_API_URL = "https://apiambipie.mohdwebsolution.in";
//export const BASE_API_URL = "https://localhost:7255";
export default {
  BASE_API_URL,
};